import {configureStore,combineReducers} from "@reduxjs/toolkit"
import cartReducer from "./cartRedux"
import userReducer from "./userRedux"

import storage from 'redux-persist/lib/storage'
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import { persistStore } from 'redux-persist'

const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist: ['apiProductSlice'],
  }
 
const rootReducer=combineReducers({user:userReducer,cart:cartReducer})

const persistedReducer = persistReducer(persistConfig, rootReducer)
//userReducer we want to persist

const store=configureStore({
    reducer:persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
})

export let persistor = persistStore(store)
export default store